import React from "react";
import { DLS_TEXT_VARIANTS } from "../../../constants/dls";
import { Images } from "../../../constants/images";
import { LeftGradientLine, ReferEarnContainer, ReferEarnText, RightGradientLine } from "../../../styles/home";
import {
    EarningsCard,
    EarningsSection,
    EarningsDivider,
    EarningsValue,
    EarningsAmount,
    EarningsLabel,
    EarningsIcon,
} from "../../../styles/referralEarnings";
import { IReferralData } from "../../../interfaces/home";

interface ReferralEarningsSuccessViewProps {
    earningsData: IReferralData;
}

const ReferralEarningsSuccessView = ({ earningsData }: ReferralEarningsSuccessViewProps) => {
    return (
        <>
            <ReferEarnContainer>
                <LeftGradientLine />
                <ReferEarnText variant={DLS_TEXT_VARIANTS.OVERLINE_NEUTRAL_BOLD_SPACED}>
                    REFERRAL EARNINGS
                </ReferEarnText>
                <RightGradientLine />
            </ReferEarnContainer>
            <EarningsCard>
                <EarningsSection>
                    <EarningsValue variant={DLS_TEXT_VARIANTS.HEADER_H2_BLACK}>
                        {earningsData?.total_referrred}
                    </EarningsValue>
                    <EarningsLabel variant={DLS_TEXT_VARIANTS.OVERLINE_NEUTRAL_MEDIUM}>
                        <EarningsIcon src={Images.bag} />
                        Referred
                    </EarningsLabel>
                </EarningsSection>
                <EarningsDivider />
                <EarningsSection>
                    <EarningsValue variant={DLS_TEXT_VARIANTS.HEADER_H2_BLACK}>
                        {earningsData?.total_pending}
                    </EarningsValue>
                    <EarningsLabel variant={DLS_TEXT_VARIANTS.OVERLINE_NEUTRAL_MEDIUM}>
                        <EarningsIcon src={Images.time} />
                        Pending
                    </EarningsLabel>
                </EarningsSection>
                <EarningsDivider />
                <EarningsSection>
                    <EarningsAmount variant={DLS_TEXT_VARIANTS.HEADER_H2_BLACK}>
                        {earningsData?.earned_amount}
                    </EarningsAmount>
                    <EarningsLabel variant={DLS_TEXT_VARIANTS.OVERLINE_NEUTRAL_MEDIUM}>
                        <EarningsIcon src={Images.earnings} />
                        Earnings
                    </EarningsLabel>
                </EarningsSection>
            </EarningsCard>
        </>
    );
};

export default ReferralEarningsSuccessView;
